import { UNSUPPORTED_BROWSER_ERROR_CAUSE } from '../components/camera/hooks/use-user-media';
import type { CameraErrorCause } from '../types';

const getCameraErrorCause = (error: unknown): CameraErrorCause => {
  if (!(error instanceof Error)) {
    return 'other-error';
  }

  if (error instanceof TypeError) {
    return 'undefined-navigator';
  }
  if (error.cause === UNSUPPORTED_BROWSER_ERROR_CAUSE) {
    return 'unsupported-browser';
  }
  if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
    return 'not-found';
  }
  if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
    return 'already-in-use';
  }
  if (error.name === 'OverconstrainedError' || error.name === 'ConstraintNotSatisfiedError') {
    return 'constraint';
  }
  if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
    return 'permission-denied';
  }
  return 'other-error';
};

export default getCameraErrorCause;
